import { SIGNUP_BACKEND_URL } from '@/config';
import { GeoClientData } from '@/lib/AbstractAPI/types';
import axios from '@/lib/axios';

export const getGeoClientData = (): Promise<GeoClientData> => {
  const endPoint = SIGNUP_BACKEND_URL + 'ip';

  return axios.get(endPoint).then((response: any) => response);
};
